export default __webpack_public_path__ + "static/flessibilita-sul-lavoro-b7e3b102e49eecffadfebb6659e03b08.jpg";